import Helmet from "react-helmet"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

import Routes from "./Router"
import DuckController from "./components/DuckController"
import Snackbars from "./components/Snackbars"
import heroPatternCss from "@podcastsoundboard/ps-lib/css/hero-patterns.css?inline"
import tailwindCss from "./css/tailwind.css?inline"
import styleCss from "./css/index.css?inline"
import scrollbarCss from "@podcastsoundboard/ps-lib/css/hide-scrollbar.css?inline"
import { darkSvgBackground, lightSvgBackground } from "./lib/muiTheme"
import { useAppSelector } from "./redux"

export function App() {
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)

  return (
    // messes up wavesurfer by initializing twice
    // <React.StrictMode>
    <QueryClientProvider
      client={
        new QueryClient({
          defaultOptions: {
            queries: {
              refetchOnWindowFocus: false,
            },
          },
        })
      }
    >
      <style dangerouslySetInnerHTML={{ __html: tailwindCss }} />
      <style dangerouslySetInnerHTML={{ __html: styleCss }} />
      <style dangerouslySetInnerHTML={{ __html: scrollbarCss }} />
      <style
        dangerouslySetInnerHTML={{
          __html: `body { background-color: ${darkModeEnabled ? darkSvgBackground : lightSvgBackground} }`,
        }}
      />
      <style dangerouslySetInnerHTML={{ __html: heroPatternCss }} />

      <Helmet
        defaultTitle="Podcast Soundboard"
        titleTemplate="%s | Podcast Soundboard"
      />

      <DuckController />
      <Snackbars />
      <Routes />
    </QueryClientProvider>
  )
}
